import type { VehicleFieldsData } from '@/components/vehicles/VehicleFormFields';
import type { VehicleLookupResult } from '@/hooks/useVehicleLookup';

/**
 * Merge a registry (external) vehicle lookup result into the new-vehicle form
 * data, prefilling the plate the user typed. Registry values only overwrite a
 * field when they are non-empty, so anything the user already entered is kept.
 *
 * Used when a plate lookup matches the external registry but not our own DB:
 * the create-new-vehicle form is opened automatically, prefilled from here,
 * with no extra click (issue #562).
 */
export function mergeExternalVehicleData(
  prev: VehicleFieldsData,
  registrationNumber: string,
  data: VehicleLookupResult,
): VehicleFieldsData {
  return {
    ...prev,
    registrationNumber,
    make: data.make || prev.make,
    model: data.model || prev.model,
    year: data.year?.toString() || prev.year,
    vin: data.vin || prev.vin,
  };
}
